import { Column, ColumnStore } from '@bryntum/grid';
import {$t} from "../../i18Instance";

/**
 * Beschreibt die Verfügbarkeit für Mietanträge im gewählten Zeitraum
 */
export class RmsObjectsGridColumnCurrentAvailability extends Column {
    // Define the type for this column, used in your columns config to add this column
    static get type() {
        return 'currentAvailabilityColumn';
    }

    // Override default values
    static get defaults() {
        return {
            field: 'hasRentsOrRequestsInDate',
            align: 'center',
            cellCls: 'custom-cell-image',
            editor: false,
            htmlEncode: false,
            tooltipRenderer : ({ record }) => {
                if(record.hasRentsInDate === true){
                    return "<div>" + $t('requests.grid.not-available-in-period') + "</div><div class='small'>" + $t('requests.grid.elem-not-available-in-period') + "</div>";
                }
                if(record.hasRequestsInDate === true){
                    return "<div>" + $t('requests.grid.already-requested-in-period') + "</div><div class='small'>" + $t('requests.grid.elem-limited-availability-in-period') +"</div>";
                }
                if(record.hasRentsOrRequestsInDate === false){
                    return $t('requests.grid.available-in-period');
                }
            }
        };
    }

    renderer({ record, value, cellElement, row, size}) {
        // hasRentsOrRequestsInDate - Sind Aufträge oder Anträge im Zeitraum?
        if(value === true){
            // Aufträge
            /*
            for (const rentInDate of record.rentsInDate) {
                row.addCls('row-not-available');
                row.removeCls('row-restricted-availability');
                return '<i class="fad fa-circle fa-2x" style="color: red;"></i>';
            }*/
            if(record.hasRentsInDate === true){
                row.addCls('row-not-available');
                row.removeCls('row-restricted-availability');
                return '<i class="fad fa-circle fa-2x" style="color: red;"></i>';
            }

            // Anträge
            /*
            for (const requestInDate of record.requestsInDate){
                row.addCls('row-restricted-availability');
                row.removeCls('row-not-available');
                return '<i class="fad fa-circle fa-2x" style="color: orange;"></i>';
            }*/
            if(record.hasRequestsInDate === true){
                row.addCls('row-restricted-availability');
                row.removeCls('row-not-available');
                return '<i class="fad fa-circle fa-2x" style="color: orange;"></i>';
            }
        }else{
            row.removeCls('row-restricted-availability');
            row.removeCls('row-not-available');
            return '<i class="fad fa-circle fa-2x" style="color: green;"></i>';
        }

    }
};

ColumnStore.registerColumnType(RmsObjectsGridColumnCurrentAvailability);
